export const FETCH_FAILED = "Failed to fetch";

export const IP_BLOCK = "800001";
